import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center text-18px cursor-pointer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "md:block hidden" }, "everVision", -1)
const _hoisted_4 = { class: "flex items-center text-14px" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "md:ml-16 ml-6 cursor-pointer"
}, "Home", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://medium.com/everfinance",
  class: "md:ml-16 ml-6 cursor-pointer",
  target: "_blank"
}, "News", -1)

import { goHTMLPosition } from '@/libs/util'


export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  props: {
    scrollTop: null,
    windowWidth: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["md:h-20 back h-16 z-40 md:px-16 px-5 flex justify-between font-inter-medium items-center fixed top-0 w-full", __props.scrollTop > (__props.windowWidth > 640 ? 848 : 456) ? 'navber_white_filter text-black' : __props.scrollTop > 0 ? 'navber_black_filter text-white' : 'text-white'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: require(`@/images/${__props.scrollTop > (__props.windowWidth > 640 ? 848 : 456) ? 'ever_logo_black' : 'ever_logo_white'}.png`),
        class: "md:w-10 md:h-10 w-8 h-8 mr-1.5",
        alt: "everVision logo"
      }, null, 8, _hoisted_2),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", {
        class: "md:ml-16 ml-6 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goHTMLPosition)('solutions')))
      }, " Solutions "),
      _hoisted_6
    ])
  ], 2))
}
}

})